import React from 'react';
import { Paper, Typography, Button, Box } from '@mui/material';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';
import DropZone from './DropZone';
import FilePreview from './FilePreview';

const UploadSection = ({ 
  title, 
  files, 
  type, 
  multiple, 
  disabled, 
  onDrop, 
  onFileChange, 
  onRemoveFile 
}) => {
  return (
    <Paper 
      elevation={0}
      sx={{ 
        p: 3, 
        mb: 2, 
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        backgroundColor: '#ffffff',
      }}
    >
      <Typography variant="h6" color="primary.dark" fontWeight="500" sx={{ mb: 2 }}>
        {title}
      </Typography>
      
      <DropZone
        onDrop={onDrop}
        isDragging={false}
        disabled={disabled}
      >
        <input
          id={`file-input-${type}`}
          type="file"
          hidden
          onChange={(e) => onFileChange(e.target.files)}
          multiple={multiple}
          accept=".pdf,.doc,.docx,.xls,.xlsx"
        />
        <CloudUploadIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
        <Typography variant="body1" color="primary.main" align="center" sx={{ mb: 1 }}>
          גרור קבצים לכאן או
        </Typography>
        <Button
          component="span"
          variant="outlined"
          disabled={disabled}
          onClick={() => document.getElementById(`file-input-${type}`).click()}
          sx={{
            backgroundColor: '#ffffff',
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.main',
              color: '#ffffff',
            },
            height: '48px',
            px: 3,
          }}
        >
          בחר קבצים
        </Button>
        {/* <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
          PDF, Word או Png
        </Typography> */}
      </DropZone>

      <Box sx={{ mt: 2 }}>
        {(Array.isArray(files) ? files : files ? [files] : []).map((file, index) => (
          <FilePreview
            key={index}
            file={file}
            onRemove={() => onRemoveFile(index)}
          />
        ))}
      </Box>
    </Paper>
  );
};

export default UploadSection;